import { useSetting } from '@/contexts/CompanyContext';
import React from 'react';

interface IProps {
  titleEn: string;
}

const TemplateHeaderExport = ({ titleEn }: IProps) => {
  const { setting } = useSetting();
  return (
    <div className="flex flex-row justify-between gap-5 mt-2 border-y border-black mb-8 pt-2 pb-2">
      <div className="flex min-w-[150px] justify-center items-center">
        <img src="/allied-logo.jpg" alt="" style={{ maxHeight: 60 }} />
      </div>
      <div className="flex justify-start flex-col gap-2">
        <div className="flex justify-start flex-row gap-2">
          <div className="flex flex-col  justify-end text-sm">
            <div className="font-bold">{`${setting?.companyNameEn || ''}`}</div>
            <div>{`${setting?.companyAddressBillingEn || ''}`}</div>
          </div>
          <div className="text-xl font-bold flex justify-end text-right min-w-[250px]">
            {titleEn}
          </div>
        </div>
        <div className="flex flex-row justify-between text-xs">
          <div>{`Email: ${setting?.companyEmail || ''}`}</div>
          <div>{`Tel: ${setting?.companyPhoneNumber || ''}`}</div>
          <div>{`Tax ID: ${setting?.companyTaxId || ''}`}</div>
        </div>
      </div>
    </div>
  );
};

export default TemplateHeaderExport;
